import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { isFunction } from 'lodash';
import classnames from 'classnames';

export class NotificationBanner extends React.Component {
  constructor (props) {
    super(props);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
  }

  componentDidMount () {
    const { timing = 4, staticBanner } = this.props;
    if (staticBanner) { return undefined; }
    return setTimeout(() => {
      this.closeBanner();
    }, parseInt(timing, 10) * 1500);
  }

  closeBanner () {
    const { closeBanner } = this.props;
    if (isFunction(closeBanner)) {
      return closeBanner();
    }
    return ReactDOM.unmountComponentAtNode(document.getElementById('banner-container'));
  }

  handleCloseClick (e) {
    e.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.closeBanner();
  }

  render () {
    const {
      timing = 4,
      staticBanner,
      message,
      outerBannerClass = '',
      customClass = '',
      showClose,
      style,
      backgroundColor
    } = this.props;

    const bannerClass = classnames(
      'banner-outer-container',
      outerBannerClass,
      {
        'static-notification': staticBanner,
        'animated-notification': !staticBanner
      }
    );

    return (
      <div className={bannerClass}>
        <div
          className={`banner-container flex center middle ${backgroundColor} ${customClass}`}
          style={{ ...style, animationDuration: `${timing.toString()}s` }}
        >
          {
            message ?
              <div className="notification-banner-message">
                { message }
              </div>
              : null
          }
          {
            showClose &&
              <button className="btn-link no-gutter remove-click-styling close-btn-container" onClick={this.handleCloseClick}>
                <i className="icon-close-sidebar text-white" />
              </button>
          }
        </div>
      </div>
    );
  }
}

NotificationBanner.defaultProps = {
  backgroundColor: 'bg-green-200',
  customClass: ''
};

NotificationBanner.propTypes = {
  message: PropTypes.object.isRequired,
  showClose: PropTypes.bool,
  timing: PropTypes.number,
  staticBanner: PropTypes.bool,
  customClass: PropTypes.string,
  onClose: PropTypes.func,
  style: PropTypes.object,
  outerBannerClass: PropTypes.string,
  closeBanner: PropTypes.func,
  backgroundColor: PropTypes.string
};
